import Vue from 'vue'
import axios from 'axios'
import store from '@/store';

/*
  returns result: {data, error}
  where error = {code,message}
  where code:
  INTERNAL_SERVER_ERROR
  GRAPHQL_VALIDATION_FAILED
  FORBIDDEN
  BAD_USER_INPUT
  NOT_FOUND
  DUPLICATE
  OTHER
*/

const apiMap = [{api:'purtrak',uri:process.env.VUE_APP_PURTRAK_API},
                {api:'shopify',uri:process.env.VUE_APP_SHOPIFY_API},
                {api:'square',uri:process.env.VUE_APP_SQUARE_API},
                {api:'portal',uri:process.env.VUE_APP_PORTAL_API}];

const apiCall = {
	install(Vue) {
		Vue.prototype.$apiCall = async function(query, variables, doNotShowErrors = false, api = 'purtrak') {
      const accessToken = await Vue.prototype.$auth.getTokenSilently();

      const uri = apiMap.find(a => a.api === api).uri;
      const response = !accessToken ||
                        await axios.post(`${uri}/${store.state.companyId?store.state.companyId:''}`,
                                        {query:query, variables:variables},
                                        { headers: {Authorization: `Bearer ${accessToken}`, 'purtrak-version':store.state.version}, validateStatus: () => {return true}});
      if (!accessToken || response.status === 401 || response.status === 500) { // Invalid token - clear user info
        store.commit('clearUser');
        Vue.prototype.$auth.login();
        return {error:true};
      }

      if (api === 'purtrak')
        store.commit('setVersion', response.headers['purtrak-version']);

      let error = null;
      if (response.data.errors) {
        const extensions = response.data.errors[0].extensions;
        if (extensions?.code === 'VALIDATION_ERROR' || extensions?.code === 'SYNTAX_ERROR') {
          error = `It looks like something went wrong internally. We logged the problem and will look into it ASAP.`;

          // We want to know internally what is going on
          await axios.post(`${process.env.VUE_APP_PURTRAK_API}/${store.state.companyId?store.state.companyId:''}`,
                                        {query:`mutation ClientError($input:ClientErrorInput!) {
                                                  logClientError(input:$input)
                                                }`,
                                        variables:{input:{query, variables:JSON.stringify(variables), error:response.data.errors[0].message}}},
                                        {headers: {Authorization: `Bearer ${accessToken}`}, validateStatus: () => {return true}});
        }
        else if (extensions?.code === 'INTERNAL_SERVER_ERROR') {
          error = `Oops. It looks like something went wrong internally. This is our fault and we'll look into it immediately.`;
          console.error(response.data.errors);
        }
        else
          error = response.data.errors[0].message;
      }
      if (error == null)
        error = response.data.error;
      if (error && !doNotShowErrors && store)
        store.commit('setError', {type:'error',message:error, code:response.data.errors[0]?.extensions?.code, info:response.data.errors[0]?.extensions?.info});
      if (response.status === 400)
        console.error(error);

      const result = {data:response.data.data};
      if (error)
        result.error = {message:error, code:response.data.errors[0]?.extensions?.code, info:response.data.errors[0]?.extensions?.info};
      return result;
		}
	}
}

Vue.use(apiCall);
